"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIconStyle = exports.ButtonIconColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var ButtonIconColor;
(function (ButtonIconColor) {
    ButtonIconColor["Inherit"] = "Inherit";
    ButtonIconColor["Primary"] = "Primary";
    ButtonIconColor["Default"] = "Default";
    ButtonIconColor["Green"] = "Green";
    ButtonIconColor["Red"] = "Red";
    ButtonIconColor["Orange"] = "Orange";
    ButtonIconColor["Blue"] = "Blue";
    ButtonIconColor["Violet"] = "Violet";
    ButtonIconColor["Pink"] = "Pink";
})(ButtonIconColor || (exports.ButtonIconColor = ButtonIconColor = {}));
var ButtonIconStyle;
(function (ButtonIconStyle) {
    ButtonIconStyle["PrimaryContrast"] = "PrimaryContrast";
    ButtonIconStyle["PrimaryContrastFilled"] = "PrimaryContrastFilled";
    ButtonIconStyle["PrimaryColored"] = "PrimaryColored";
    ButtonIconStyle["PrimaryColoredFilled"] = "PrimaryColoredFilled";
    ButtonIconStyle["SecondaryBlack"] = "SecondaryBlack";
    ButtonIconStyle["SecondaryGrey"] = "SecondaryGrey";
    ButtonIconStyle["SmallColored"] = "SmallColored";
    ButtonIconStyle["SmallMono"] = "SmallMono";
    ButtonIconStyle["SmallClose"] = "SmallClose";
    ButtonIconStyle["Topbar"] = "Topbar";
    ButtonIconStyle["Table"] = "Table";
})(ButtonIconStyle || (exports.ButtonIconStyle = ButtonIconStyle = {}));
const ButtonIcon = react_1.default.forwardRef(({ disabled, children, onClick, color = ButtonIconColor.Primary, style = ButtonIconStyle.PrimaryContrast, active, onClickCapture, ...rest }, ref) => ((0, jsx_runtime_1.jsx)("button", { ref: ref, type: "button", className: (0, classnames_1.default)(styles_module_css_1.default.buttonIcon, styles_module_css_1.default[`buttonIcon${style}`], styles_module_css_1.default[`buttonIcon${color}`], { [styles_module_css_1.default.buttonIconActive]: active }), onClick: onClick, onClickCapture: onClickCapture, disabled: disabled, ...rest, children: children })));
exports.default = ButtonIcon;
